import { useSelector } from 'react-redux';
import { specialtyTypesIsLoadedSelector } from '../../../../selectors/specialtyTypes/specialtyTypesIsLoadedSelector';
import { IApplicationState } from '../../../../types/redux';
import { TSpecialtyTypes } from '../../../../types/specialtyTypes';

export function useSpecialtyTypesIsLoadedSelector(): boolean {
  return useSelector<IApplicationState, TSpecialtyTypes['isLoaded']>(specialtyTypesIsLoadedSelector);
}
